import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostResetPassword = () => {
  return useMutation({
    mutationFn: authService.postResetPassword,
    throwOnError: false,
  });
};
